module.exports = __webpack_public_path__ + "img/mstation-product.af7144bc.jpg";